import React from 'react';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';

const NOT_ALLOWED_MESSAGE = `The user doesn't have permission to access`;
export default function NotAllowed() {
  toast(NOT_ALLOWED_MESSAGE);
  return <Redirect to="/login" />;
}
